import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDataTable,{staticClass:"details-table",attrs:{"hide-default-footer":"","headers":_vm.header,"items":_vm.courses,"items-per-page":-1},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('TableRow',{ref:"tableRow",attrs:{"table-name":"scheduleCourses","item":item,"header":_vm.header}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }